document.addEventListener("turbo:load", () => {
  const toggle = document.getElementById("theme-toggle");
  if (!toggle) return;
  toggle.addEventListener("click", () => {
    const html = document.documentElement;
    html.classList.toggle("dark");
    localStorage.setItem("vm-theme", html.classList.contains("dark") ? "dark" : "light");
  });
  const saved = localStorage.getItem("vm-theme");
  if (saved === "dark") document.documentElement.classList.add("dark");
});


